import {BlockType} from "../../model/markdown/MarkdownText"
import {codeBlockParserService} from "./codeBlockParserService"
import {listParserService} from "./listParserService"
import {quoteBlockParserService} from "./quoteBlockParserService"
import {tableParserService} from "./tableParserService"

export interface ParsedBlock {
    content: string
    offset: number
    type: BlockType
    lineSkipped: number
    subBlocks: Array<ParsedBlock>
    startFrom: number
    hint: string
    indent: number
}

class BlockParseService {
    getParsedBlock(line: string, lines: Array<string>, lineNo: number): ParsedBlock {
        let type = BlockType.PARAGRAPH
        let offset = 0
        let indent = 0
        while (offset < line.length) {
            if (line[offset] > ' ') {
                break
            }
            offset++
            indent++
        }
        let identOffset = offset
        let headerLevel = 0
        while (offset < line.length) {
            const curChar = line[offset]
            if (curChar === '#' && headerLevel >= 0) {
                headerLevel++
                identOffset++
                if (headerLevel >= 6) {
                    type = BlockType.HEADER_6
                    break
                }
            } else if (offset === 0 && quoteBlockParserService.isQuoteBlock(curChar)) {
                return quoteBlockParserService.getBlock(line, offset, identOffset, indent, lines, lineNo)
            } else if (curChar === ' ') {
                if (headerLevel > 0) {
                    identOffset++
                    type = this.getHeaderWithLevel(headerLevel)
                    break
                }
                offset++
                break
            } else if (offset === identOffset && listParserService.isOrderedList(curChar, line, offset)) {
                return listParserService.getOrderedList(line, offset, lines, lineNo, indent)
            } else if (offset === identOffset && listParserService.isUnorderedList(curChar, line, offset)) {
                return listParserService.getUnorderedList(line, offset, lines, lineNo, indent)
            } else if (offset === identOffset && codeBlockParserService.isCodeBlock(curChar, line, offset)) {
                return codeBlockParserService.getCodeBlock(line, offset, lines, lineNo)
            } else if (offset === identOffset && tableParserService.isTableLine(line, offset)) {
                return tableParserService.getTable(line, offset, lines, lineNo)
            } else {
                headerLevel = -1
            }
            offset++
        }
        return {
            offset,
            type,
            content: line.substring(identOffset),
            lineSkipped: 0,
            subBlocks: [],
            startFrom: 1,
            hint: '',
            indent,
        }
    }

    private getHeaderWithLevel(level: number) {
        switch (level) {
            case 1:
                return BlockType.HEADER_1
            case 2:
                return BlockType.HEADER_2
            case 3:
                return BlockType.HEADER_3
            case 4:
                return BlockType.HEADER_4
            case 5:
                return BlockType.HEADER_5
            case 6:
                return BlockType.HEADER_6
            default:
                return BlockType.HEADER_6
        }
    }
}

export const blockParseService = new BlockParseService()
